import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getBulletinsContent = createAsyncThunk(
  "/bulletins/content",
  async () => {
    const response = await axios.get("/api/users?page=2", {});
    return response.data;
  },
);

export const bulletinsSlice = createSlice({
  name: "bulletins",
  initialState: {
    isLoading: false,
    bulletins: [],
  },
  reducers: {
    addNewBulletin: (state, action) => {
      let { newBulletinObj } = action.payload;
      state.bulletins = [...state.bulletins, newBulletinObj];
    },

    deleteBulletin: (state, action) => {
      let { index } = action.payload;
      state.bulletins.splice(index, 1);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getBulletinsContent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBulletinsContent.fulfilled, (state, action) => {
        state.bulletins = action.payload.data;
        state.isLoading = false;
      })
      .addCase(getBulletinsContent.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { addNewBulletin, deleteBulletin } = bulletinsSlice.actions;

export default bulletinsSlice.reducer;
